import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { DynamicSpecSheet, ZipDownloadPath } from "@/features/sub-families/types";
import type { DownloadOption } from "@/types";

type State = {
    allowedOptions: DownloadOption[];
    dynamicSpecSheetPath: DynamicSpecSheet;
    zipDownloadPath: ZipDownloadPath;
};

const initialState: State = {
    allowedOptions: [],
    dynamicSpecSheetPath: "" as DynamicSpecSheet,
    zipDownloadPath: "" as ZipDownloadPath,
};

const slice = createSlice({
    name: "downloads",
    initialState,
    reducers: {
        downloadsSetAllowedOptionsAction: (state: State, action: PayloadAction<DownloadOption[]>) => {
            state.allowedOptions = action.payload;
        },
        downloadsSetDynamicSpecSheetPathAction: (state: State, action: PayloadAction<DynamicSpecSheet>) => {
            state.dynamicSpecSheetPath = action.payload;
        },
        downloadsSetZipDownloadPathAction: (state: State, action: PayloadAction<ZipDownloadPath>) => {
            state.zipDownloadPath = action.payload;
        },
    },
});

export const {
    downloadsSetAllowedOptionsAction,
    downloadsSetDynamicSpecSheetPathAction,
    downloadsSetZipDownloadPathAction,
} = slice.actions;

export default slice.reducer;
